import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articleCategories } from '@/mocks/articles';
import { seoConfig } from '@/mocks/seo';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 text-white mb-4 whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-white text-xl"></i>
                </div>
                <span className="text-xl font-heading font-bold">{seoConfig.siteName}</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                {seoConfig.siteName}品牌提供红桃视频、西瓜视频免费、小蓝视频等综合平台免费在线观看，高清画质不缓冲，久久视频芒果视频全集资源一站畅享。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="QQ">
                  <i className="ri-qq-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-white font-heading text-base mb-4">视频平台</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      <i className={`${cat.icon} mr-2 text-xs`}></i>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-heading text-base mb-4">资讯分类</h4>
              <ul className="space-y-2">
                {articleCategories.map((cat) => (
                  <li key={cat.slug}>
                    <span className="text-sm text-background-400">
                      <i className="ri-article-line mr-2 text-xs"></i>
                      {cat.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-heading text-base mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {seoConfig.siteName}. 版权所有.
            </p>
            <p className="text-xs text-background-500">
              <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">京ICP备XXXXXXXX号</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">网络视听许可证</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}